import ToggleState from 'javascripts/modules/toggle-state.js';

class EffectZoom {

  constructor(){
    this._init();
  }

  _init(){

    document.addEventListener('DOMContentLoaded', (event) => {

      new ToggleState('effect-zoom', 'active', 'inactive', true);

    });
  }


}

export let effectZoom = new EffectZoom();
